import { createLoggerGetter, AppName } from '@bowtie-web/common/lib/logging';

type Feature =
  | 'coupon'
  | 'validation'
  | 'quotation'
  | 'product'
  | 'auth'
  | 'experiment';

const getLogger = createLoggerGetter<Feature>(AppName.Quotation);

export default getLogger;
